import { FormikProps } from 'formik';
// mantine
import { NumberInput, Select, JsonInput, Textarea } from '@mantine/core';
// utils
import { TAttributeData, TRole } from '@newo/api/gateway';

interface AttributeValueProps {
    formik: FormikProps<TAttributeData>;
    role?: TRole;
}

const AttributeValue = ({ formik }: AttributeValueProps) => {
    /* eslint-disable sonarjs/function-return-type */
    const getValue = () => {
        switch (formik.values.value_type) {
            case 'number': {
                return +formik.values.value;
            }
            case 'json': {
                return formik.values.value;
            }
            default: {
                return formik.values.value;
            }
        }
    };

    const handleValueChange = (value: unknown) => {
        switch (formik.values.value_type) {
            case 'number': {
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                formik.setFieldValue('value', `${value}`);
                break;
            }
            case 'json': {
                formik.setFieldValue('value', value);
                return;
            }
            default: {
                formik.setFieldValue('value', value);
            }
        }
    };

    return (
        <>
            {formik.values.value_type === 'enum' ? (
                <Select
                    data={formik.values.possible_values}
                    error={
                        formik.touched.value && formik.errors.value
                            ? formik.errors.value
                            : undefined
                    }
                    name="value"
                    value={getValue() as string}
                    onChange={handleValueChange}
                />
            ) : undefined}
            {formik.values.value_type === 'string' ? (
                <Textarea
                    autosize
                    error={
                        formik.touched.value && formik.values.value
                            ? formik.errors.value
                            : undefined
                    }
                    maxRows={30}
                    minRows={3}
                    name="value"
                    placeholder="Value"
                    value={getValue()}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                />
            ) : undefined}
            {formik.values.value_type === 'bool' ? (
                <Select
                    data={['True', 'False']}
                    name="value"
                    value={getValue() as string}
                    onChange={handleValueChange}
                />
            ) : undefined}
            {formik.values.value_type === 'number' ? (
                <NumberInput
                    error={
                        formik.touched.value && formik.values.value
                            ? formik.errors.value
                            : undefined
                    }
                    value={getValue()}
                    onChange={handleValueChange}
                />
            ) : undefined}
            {formik.values.value_type === 'json' ? (
                <JsonInput
                    autosize
                    error={formik.errors.value}
                    maxRows={40}
                    minRows={3}
                    value={getValue() as string}
                    onChange={handleValueChange}
                />
            ) : undefined}
        </>
    );
};

export default AttributeValue;
